import { useState } from "react";
import { useGoogleTag } from "../../../hooks/useGoogleTag";
import { Button } from "../../../cookies/icons/Button";

export const StepMainUse = ({ handleMainUse }: { handleMainUse: (type: string) => void }) => {
    useGoogleTag('StepMainUse');
    const tabs = [
        {
            icon: "🎬",
            title: "Netflix et TV",
            subtitle: ""
        },
        {
            icon: "🎮",
            title: "Jeux en ligne",
            subtitle: "Console, PC gaming"
        },
        {
            icon: "💼",
            title: "Télétravail",
            subtitle: "Visio, navigation, email"
        },
    ];
    const [selectedMainUse, setSelectedMainUse] = useState<any[]>([])
    const [error, setError] = useState<boolean>(false);

    const answerQuestion = () => {
        if (selectedMainUse.length === 0) {
            setError(true);
            return;
        }
        handleMainUse(selectedMainUse.join(", "));
    }

    const selectedMain = (data: string) => {
        setSelectedMainUse(prev =>
            prev.includes(data) ? prev : [...prev, data]
        );
    }
    return (
        <>
            <div className="w-full">
                <div className="flex flex-col gap-10 md:pb-10">
                    <h3 className="text-center font-bold text-xl lg:text-lg">Quels sont vos <span className="text-primaryNewComparateurFibre">usages principaux d'internet</span> ?</h3>
                    <div className="flex flex-col gap-4 px-4 md:px-6">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 sm:gap-3 md:gap-4 lg:gap-1.5">
                            {tabs.map((tab, index) => (
                                <button key={index} onClick={() => selectedMain(tab.title)} className={`group relative h-28 md:h-auto p-4 sm:p-5 md:p-4 lg:p-2 rounded-xl md:rounded-2xl lg:rounded-[.8rem] border-2 border-2 text-left transition-all duration-300 ease-spring hover:scale-[1.01] sm:hover:scale-[1.02] active:scale-[0.98] bg-card border-border hover:shadow-card flex flex-col gap-1 justify-center items-center ${selectedMainUse.includes(tab.title) ? "border-primaryNewComparateurFibre bg-primaryNewComparateurFibre/5" : "hover:border-primaryNewComparateurFibre hover:text-primaryNewComparateurFibre hover:bg-white"}`}>
                                    <span className="text-2xl">{tab.icon}</span>
                                    <span className="flex flex-col">
                                        <span className="text-[19px] font-medium text-center sm:text-base md:text-lg lg:text-[15px] mx-auto">{tab.title}</span>
                                        <span className="text-[17px] text-center sm:text-base md:text-lg lg:text-sm mx-auto">{tab.subtitle}</span>
                                    </span>
                                    <span className={`${selectedMainUse.includes(tab.title) ? '' : 'hidden'} absolute right-2 top-2 rounded p-1 flex items-center justify-center border-gray-400 border-[1px] bg-primaryNewComparateurFibre`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="text-white w-3 h-3">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                        </svg>
                                    </span>
                                </button>
                            ))}
                        </div>
                        {error && <p className="text-red-500 text-sm lg:text-[13px] font-medium bg-red-100 rounded-lg px-2 py-1.5 lg:py-2 text-center">Veuillez sélectionner une case</p>}
                        <Button onClick={answerQuestion} className="w-full bg-primaryNewComparateurFibre rounded-xl font-bold text-md">Continuer</Button>
                    </div>
                </div>
            </div>
        </>
    );
};
